export default "__VITE_ASSET__ccae5034__"